module.exports = __webpack_public_path__ + "assets/coin.93ebbeeb.svg";